import { Col, Container, Row } from "reactstrap";
import React from "react";
import RegionSelector from "../RegionSelector";
import { APP_VERSION, HIDE_COMPLIANCE_MARKS } from "../../config/env";
import "./LoginFooter.scss";

export default () => (
  <Container>
    <Row className="justify-content-center">
      <Col md="8" sm={12}>
        <div className="d-flex justify-content-center align-items-center">
          <div>
            <RegionSelector
              className="drop-up"
              style={{
                backgroundColor: "transparent",
                border: 0,
                width: 100,
                height: 30,
              }}
            />
          </div>
          {!HIDE_COMPLIANCE_MARKS && (
            <>
              <div className="mx-1">
                <img
                  src="/img/ce-mark.png"
                  height={20}
                  alt="myPatientSpace - CE Mark"
                />
              </div>
              <div>
                <img
                  src="/img/mps-iso.png"
                  height={20}
                  alt="myPatientSpace - ISO"
                />
              </div>
            </>
          )}
          {APP_VERSION && (
            <div className="login-footer__version">v{APP_VERSION}</div>
          )}
        </div>
      </Col>
    </Row>
  </Container>
);
